var exports = {
  "O": "chatInputContainer__JYaT6L",
};

module.exports = exports;
